const env: string =
  window.localStorage.getItem('survey:debug:env') ||
  process.env.APP_ENV ||
  'production';

type ConfigType = {
  HOST: string;
  CLIENT_ID?: string;
  FRESHID_ENV?: string;
  PUBLIC_API_URL: string;
  SURVEYSERV_PUBLIC_API_URL: string;
  REPORTS_URL: string;
  SURVEY_MICROFRONTEND_REMOTE: string;
  EXTERNAL_ASSET_URL: string;
};

const production: ConfigType = {
  HOST: 'https://api.freshsurvey.io',
  PUBLIC_API_URL: 'https://public-api.freshsurvey.io',
  SURVEYSERV_PUBLIC_API_URL: 'https://surveyserv-public.freshworksapi.com',
  REPORTS_URL: 'https://freshsurvey-us.freshreports.com',
  SURVEY_MICROFRONTEND_REMOTE:
    'https://microfrontend.surveyserv.com/remoteEntry.js',
  EXTERNAL_ASSET_URL: 'https://assets.freshsurvey.io',
};

const staging: ConfigType = {
  HOST: 'https://api.sta91ng-freshsurvey.com',
  CLIENT_ID: '470165888270564142',
  FRESHID_ENV: 'SANDBOX',
  PUBLIC_API_URL: 'https://public-api.sta91ng-freshsurvey.com',
  SURVEYSERV_PUBLIC_API_URL:
    'https://surveyserv-public-staging.freshworksapi.com',
  REPORTS_URL: 'https://staging.freshreports.com',
  SURVEY_MICROFRONTEND_REMOTE:
    'https://microfrontend.sta91ng-surveyserv.com/remoteEntry.js',
  EXTERNAL_ASSET_URL: 'https://assets.sta91ng-freshsurvey.com',
};

const development: ConfigType = {
  HOST: 'https://api.prestaging.sta91ng-freshsurvey.com',
  CLIENT_ID: '383957662436652820',
  FRESHID_ENV: 'INT',
  PUBLIC_API_URL: 'https://public-api.prestaging.sta91ng-freshsurvey.com',
  SURVEYSERV_PUBLIC_API_URL:
    'https://surveyserv-public-prestaging.freshworksapi.com',
  REPORTS_URL: 'https://staging.freshreports.com',
  SURVEY_MICROFRONTEND_REMOTE:
    'https://microfrontend.prestaging.sta91ng-surveyserv.com/remoteEntry.js',
  EXTERNAL_ASSET_URL: 'https://assets.prestaging.sta91ng-freshsurvey.com',
};

const local: ConfigType = {
  HOST: 'https://api.prestaging.sta91ng-freshsurvey.com',
  CLIENT_ID: '383957662436652820',
  FRESHID_ENV: 'INT',
  PUBLIC_API_URL: 'https://public-api.prestaging.sta91ng-freshsurvey.com',
  SURVEYSERV_PUBLIC_API_URL:
    'https://surveyserv-public-prestaging.freshworksapi.com',
  REPORTS_URL: 'https://staging.freshreports.com',
  // SURVEY_MICROFRONTEND_REMOTE:
  //   'https://microfrontend.prestaging.sta91ng-surveyserv.com/remoteEntry.js',
  SURVEY_MICROFRONTEND_REMOTE: 'http://localhost:3000/remoteEntry.js',
  EXTERNAL_ASSET_URL: 'https://assets.prestaging.sta91ng-freshsurvey.com',
};

const config = {
  local,
  development,
  staging,
  production,
};

const apiVersion = 'v1';

export default config[env] as ConfigType;

if (typeof localStorage !== undefined) {
  localStorage.setItem('fswaa:env', env);
}

export const API_ROOT = `${config[env].HOST}/api/${apiVersion}`;
export const REPORTS_URL = config[env].REPORTS_URL;
